export default __webpack_public_path__ + "static/media/capa_final.dc94178c.jpg";